import React from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { useDispatch, useSelector, useStore } from 'react-redux';
import {
  fetchApi,
  makeResetCache,
  notifyError,
  notifyResponse,
  selectUser,
  selectRecordFromGCache,
  GCacheRecord,
  RecordPicker,
} from 'gossamer-front-end';
import { AdminChangeEventHostRequest, Event, InstitutionMemberView, InstitutionMemberViewRow } from 'cb-model';
import { FieldType, getFilter } from 'gossamer-unified';

interface EventChangeHostModalProps {
  eventId: number;
  institutionId: number;
  mainUserHostId: string;
  show: boolean;
  setShow: (val: boolean) => void;
}

export const EventChangeHostModal = (props: EventChangeHostModalProps) => {
  const [mainHostInstMemberId, setMainHostInstMemberId] = React.useState<string | null>(null);
  const [processing, setProcessing] = React.useState(false);
  const user = useSelector(selectUser);
  const store = useStore() as any;
  const dispatch = useDispatch();
  const resetCache = makeResetCache(dispatch);

  const handleSave = async () => {
    if (!mainHostInstMemberId) {
      return;
    }
    setProcessing(true);
    try {
      const member = selectRecordFromGCache(
        store.getState(),
        InstitutionMemberView.id,
        mainHostInstMemberId,
      ) as GCacheRecord<InstitutionMemberViewRow>;
      const response = await fetchApi('POST', `/main/event-host-change`, {
        eventId: props.eventId,
        mainHostUserId: member.data?.user_id,
      } as AdminChangeEventHostRequest);
      resetCache(Event.id, String(props.eventId));
      notifyResponse(response);
      props.setShow(false);
    } catch (e) {
      notifyError(e, 'An error occurred while changing the event host');
    }
    setProcessing(false);
  };
  return (
    <Modal
      show={props.show}
      onHide={() => props.setShow(false)}
      aria-labelledby="event-change-host-modal-title"
      size="sm"
      fullscreen="md-down"
    >
      <Modal.Header closeButton>
        <Modal.Title id="event-change-host-modal-title">Change Host</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {user?.roleId === 'user' && (
          <div>
            You will lose access to this event if you change the host to be somebody else.
            <br />
            <br />
          </div>
        )}
        <Form>
          <RecordPicker
            editable={true}
            modalTitle="Select a new main host"
            field={{
              seq: 0,
              type: FieldType.Reference,
              label: 'New Main Host',
              refEntity: InstitutionMemberView,
              refFilters: [
                getFilter('institution_id', 'eq', props.institutionId, 'hidden'),
                getFilter('is_verified', 'eq', true, 'hidden'),
              ],
            }}
            value={mainHostInstMemberId}
            onItemSelected={(value) => setMainHostInstMemberId(value || null)}
          />
          <br />
          <Button variant="primary" onClick={handleSave} disabled={processing}>
            Save
          </Button>
          <br />
        </Form>
      </Modal.Body>
    </Modal>
  );
};
